import { API } from "../apiService";

export const companiesApi = {
	// Get all companies
	async getAll() {
		const response = await API.get("companies");
		return response.data;
	},

	// Create a new company
	async create(companyData) {
		const response = await API.post("companies", companyData);
		return response.data;
	},

	// Update an existing company
	async update(id, companyData) {
		const response = await API.put(`companies/${id}`, companyData);
		return response.data;
	},

	// Delete a company by ID
	async delete(companyId) {
		const response = await API.delete(`companies/${companyId}`);
		return response.data;
	},

	// Get companies with filtering (legacy support)
	async getCompanies(companyId, name, industry) {
		const params = new URLSearchParams();
		if (companyId) params.append("companyId", companyId);
		if (name) params.append("name", name);
		if (industry) params.append("industry", industry);

		const response = await API.get(`companies?${params.toString()}`);
		return response.data;
	},

	// Get a single company by ID
	async getById(companyId) {
		const response = await API.get(`companies?companyId=${companyId}`);
		return response.data;
	},
};
